export default {
  videoAd: null,
  battlesPromo: () => null,
  premiumPromo: () => null,
};
